<div class="delivery">
    <div class="delivery-header">
        <div class="row">
            <div class="col-xs-4 delivery-info _col" [popover]="salesOrderPopTemplate" placement="top" container="body" triggers="mouseenter:mouseleave">
                <label><span [i18n]="'bluechat.detail.delivery.delivery-number'"></span>:</label>
                <h2>#{{delivery.deliveryNumber}}</h2>
            </div>
            <ng-template #salesOrderPopTemplate>
                <chp-delivery-and-sales-order-numbers
                    [deliveryNumbers]="[delivery.deliveryNumber]"
                    [salesOrderNumbers]="[delivery.salesOrderNumber]">
                </chp-delivery-and-sales-order-numbers>
            </ng-template>
            <div class="col-xs-4 delivery-info">
                <label><span [i18n]="'bluechat.detail.delivery.planned-arrival-date'"></span>: </label>
                <h3>{{delivery.destination.arrivalDateTime != null ? (delivery.destination.arrivalDateTime | date:'y-MM-dd') : '-'}}</h3>
            </div>

            <div class="col-xs-4 delivery-info text-right">
                <app-bluechat-delivery-status [displayEta]="false" [status]="delivery.status"></app-bluechat-delivery-status>
            </div>
        </div>
    </div>
    <div class="delivery-timelines">
        <div class="delivery-timelines-left">
            <app-delivery-timeline [plannedArrival]="delivery.origin.plannedDeliveryDateTime"
                                   [eta]="delivery.origin.latestEtaDateTime"
                                   [etaType]="delivery.origin.latestEtaType"
                                   [arrival]="delivery.origin.arrivalDateTime"
                                   [departure]="delivery.origin.departureDateTime"
                                   [timezoneOffset]="delivery.origin.timezoneOffset"
                                   [arrivalExclamation]="shouldPickArrivalBeInError"
                                   [departureExclamation]="shouldPickDepartureBeInError"
                                   (onShowEtaDetails)="showEtaDetailsForDeliveryAndType(delivery.deliveryNumber, StopType.Pick, delivery.origin.glid, delivery.origin.latestEtaReportId)"
            >
            </app-delivery-timeline>
            <div class="address">
                <span>
                    <h2 class="inline text-primary" [i18n]="'bluechat.detail.delivery.origin'"></h2>
                    <h2 class="inline text-primary">:&nbsp;
                        <a class="cmaweb-link" *ngIf="canManageLocations" [href]="link.goToLocationGlid(delivery.origin.glid)" target="_blank">{{delivery.origin.glid}}</a>
                        <span *ngIf="!canManageLocations">{{delivery.origin.glid}}</span>
                    </h2>
                </span>
                <h3>{{delivery.origin.locationName}}</h3>
                <p>{{delivery.origin.street}}</p>
                <p>{{delivery.origin.postalCode}}, {{delivery.origin.city}}, {{delivery.origin.countryCode}}</p>
            </div>
        </div>
        <div class="delivery-timelines-center">
            <span class="truckTransfertTimeline"><i class="fa fa-truck"></i></span>
        </div>
        <div class="delivery-timelines-right">
            <app-delivery-timeline [plannedArrival]="delivery.destination.plannedDeliveryDateTime"
                                   [eta]="delivery.destination.latestEtaDateTime"
                                   [etaType]="delivery.destination.latestEtaType"
                                   [arrival]="delivery.destination.arrivalDateTime"
                                   [departure]="delivery.destination.departureDateTime"
                                   [timezoneOffset]="delivery.destination.timezoneOffset"
                                   [arrivalExclamation]="shouldDropArrivalBeInError"
                                   [departureExclamation]="shouldDropDepartureBeInError"
                                   (onShowEtaDetails)="showEtaDetailsForDeliveryAndType(delivery.deliveryNumber, StopType.Drop, delivery.destination.glid, delivery.destination.latestEtaReportId)"
            >
            </app-delivery-timeline>
            <div class="address text-right">
                <span>
                    <h2 class="inline text-primary" [i18n]="'bluechat.detail.delivery.destination'"></h2>
                    <h2 class="inline text-primary">:&nbsp;
                        <a class="cmaweb-link" *ngIf="canManageLocations" [href]="link.goToLocationGlid(delivery.destination.glid)" target="_blank">{{delivery.destination.glid}}</a>
                        <span *ngIf="!canManageLocations">{{delivery.destination.glid}}</span>
                    </h2>
                </span>
                <h3>{{delivery.destination.locationName}}</h3>
                <p>{{delivery.destination.street}}</p>
                <p>{{delivery.destination.postalCode}}, {{delivery.destination.city}}, {{delivery.destination.countryCode}}</p>
            </div>
        </div>
    </div>
    <spacer [size]="16"></spacer>
    <div class="delivery-products ibox-content">
        <table class="table table-striped text-left">
            <thead>
            <tr>
                <th [i18n]="'bluechat.detail.delivery.product.line'"></th>
                <th [i18n]="'bluechat.detail.delivery.product.product-id'"></th>
                <th [i18n]="'bluechat.detail.delivery.product.description'"></th>
                <th [i18n]="'bluechat.detail.delivery.product.palets'"></th>
                <th><i class="fa fa-balance-scale"></i></th>
            </tr>
            </thead>
            <tbody>
            <tr  *ngFor="let product of delivery.products" class="product">
                <td>{{product.line}}</td>
                <td>{{product.productId}}</td>
                <td>{{product.description}}</td>
                <td>{{product.paletNumber}}</td>
                <td>{{product.weight}}</td>
            </tr>
            </tbody>
        </table>
    </div>
    <spacer [size]="16"></spacer>
    <div class="delivery-notes">
        <div class="delivery-notes-head">
            <h2 class="text-primary">
                <i class="fa fa-comment-medical"></i>&nbsp;
                <span [i18n]="'bluechat.detail.delivery.notes'"></span>
                ({{delivery.notes.length}})
            </h2>
            <div class="flex-column">
                <button class="btn btn-primary btn-sm m-l-sm"
                        [disabled]="!userCanCreateNote || !loadStatusAllowNoteCreation"
                        *ngIf="carrierHasBluechat"
                        (click)="createNote.emit()">
                    <i class="fa fa-comment-medical"></i>&nbsp;
                    <span [i18n]="'bluechat.detail.delivery.create-note'"></span>
                </button>
                <spacer [size]="8"></spacer>
                <span *ngIf="!carrierHasBluechat" [i18n]="'bluechat.detail.delivery.carrier-not-enabled'"></span>
                <span *ngIf="!loadStatusAllowNoteCreation"><span [i18n]="[{target:'innerHTML', key: 'bluechat.search.delivery.invalid-status'}]"></span> <span [i18n]="loadStatusI18nKey"></span></span>
            </div>
        </div>

        <table class="table table-striped text-left">
            <tbody>
                <tr *ngFor="let note of delivery.notes" class="note">
                    <td class="noteLink"><a target="_blank" [href]="note.link">{{note.subject}}</a></td>
                    <td class="noteDate">
                        <div class="date-noteCreated">
                            <span class="date-noteCreated-label" [i18n]="'bluechat.detail.delivery.note-created'"></span>
                            <span class="date">{{note.creationDate | date : dateFormat}}</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="overlay" *ngIf="showEtaDetails">
    <app-eta-details-popup [deliveryNumber]="deliveryNumberForEtaDetails"
                           [etaDestinationType]="destinationTypeForEtaDetails"
                           [etaDestinationGlid]="destinationGlidForEtaDetails"
                           [latestEtaReportId]="latestEtaReportIdForEtaDetails"
                           (close)="hideEtaDetails()"></app-eta-details-popup>
</div>
